import { computed, Injectable, signal } from '@angular/core';
import { CatalogDefault } from 'src/app/models/catalog';
import { FenderRoles, SupplierRoles } from 'src/app/models/role';
import { IUser } from 'src/app/models/user';

@Injectable({
  providedIn: 'root',
})
export class UserStoreService {
  constructor() {}

  // Me User
  private _meUser = signal<any>(null);
  readonly meUser = computed(() => this._meUser());

  // Formats
  readonly userFormats = computed(() => {
    return {
      dateFormat: this._meUser()?.dateFormat || CatalogDefault.DATE,
      timeFormat: this._meUser()?.timeFormat || CatalogDefault.TIME,
      timeZone: this._meUser()?.timeZone || CatalogDefault.TIMEZONE,
      unitOfMeasure:
        this._meUser()?.unitOfMeasure || CatalogDefault.UNIT_OF_MEASURE,
    };
  });
  readonly userEmailOptIn = computed(() => this._meUser()?.emailOptIn);
  readonly userEmailOptInData = computed(() => this._meUser()?.emailOptInData);

  // Roles
  readonly userRole = computed(() => this._meUser()?.role || undefined);
  readonly isFMIC = computed(() => {
    const user = this.meUser();
    return !!user && Object.values(FenderRoles).includes(user.role);
  });
  readonly isSupplier = computed(() => {
    const user = this.meUser();
    return !!user && Object.values(SupplierRoles).includes(user.role);
  });

  // User Supplier Number
  readonly userSupplierNumber = computed<string | null>(
    () => this._meUser()?.supplierNumber,
  );

  setMeUser(user: IUser): void {
    this._meUser.set(user);
  }
}
